import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../redux/reducers";
// api service
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
// actions
import { idConvocatorias } from "../redux/actions/convocatoriaAction";
import { nombreConvocatoria, categoriasLineasConvocatoria, guardarDatosPostulacion } from "../redux/actions/participantesAction";
// model
import { Convocatoria, initialValuesConvocatoria } from "../models/ConvocatoriasModel/convocatoria.model";
// moment
import DocumentosService from '../api/Documentos/api-documentos';
import { secuencia } from "../redux/actions/juradosAction";
import { useEncrypt } from "./useEncrypt";
import { useNavigate } from "react-router-dom";
import { ObjNotificaciones } from "../config/notificaciones";

export const UseVerConvocatorias = () => {
  // Variables redux
  const dispatch = useDispatch();
  const { decrypt } = useEncrypt();
  // State redux
  const { idParticipante, datos_postulacion } = useSelector((state: RootState) => state.participantes);
  const navigate = useNavigate();

  // States
  const [convocatoria, setConvocatoria] = useState<Convocatoria>(initialValuesConvocatoria);
  const [convocatoriaPersitente, setConvocatoriaPersitente] = useState<Convocatoria>(initialValuesConvocatoria);
  const [loading, setLoading] = useState<{ [key: string]: boolean }>({});

  // Functions
  const getConvocatoria = async (id?: number) => {
    // Validate idConvocatoria in state or in params
    const idConvocatoriaPostulacion = decrypt(localStorage.getItem('idConvocatoriaPostulacion'))
    const { data } = await apiConvocatorias.getConvocatoriaById(idConvocatoriaPostulacion);
    if (data.documentos_generales === null) data.documentos_generales = [];
    if (data.documentos_tecnicos === null) data.documentos_tecnicos = [];
    return setConvocatoria(data);
  };

  const getConvocatoriaId = async (id?: number) => {
    const { data } = await apiConvocatorias.getConvocatoriaById(id);
    if (data.length === 0) {
      ObjNotificaciones.MSG_ERROR("warning", "Convocatoria no encontrada", "Esta convocatoria no está disponible, revisa la URL")
      return navigate("/");
    }
    if (data.documentos_generales === null) data.documentos_generales = [];
    if (data.documentos_tecnicos === null) data.documentos_tecnicos = [];
    return setConvocatoria(data);
  };

  const getConvocatoriaPersistente = async () => {
    // 
    const { data } = await apiConvocatorias.getConvocatoriaById(decrypt(localStorage.getItem("idConvocatoriaPostulacion")),
    );
    if (data.documentos_generales === null) data.documentos_generales = [];
    if (data.documentos_tecnicos === null) data.documentos_tecnicos = [];
    return setConvocatoriaPersitente(data);
  }

  const inscribirPropuesta = async (convocatorias: Convocatoria, user: string) => {
    if (convocatorias.tipo !== 2) {
      dispatch(guardarDatosPostulacion({
        ...datos_postulacion,
        convocatorias: convocatorias
      }))
    }
    dispatch(idConvocatorias(convocatorias.idconvocatorias));
    dispatch(categoriasLineasConvocatoria(convocatorias.categoria_linea_convocatoria));
    dispatch(nombreConvocatoria(convocatorias.nombre_convocatoria));
    dispatch(secuencia(convocatorias.seq_jurado))
  };

  // Return functions
  const descargarArchivo = async (name: string, descripcion: string) => {
    setLoading((prev) => ({ ...prev, [descripcion]: true }));

    let data: any = await DocumentosService.consultarArchivo(name);
    const url = window.URL.createObjectURL(new Blob([data.data]));
    const link: any = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    setLoading((prev) => ({ ...prev, [descripcion]: false }));
  };
  return { convocatoria, setConvocatoria, getConvocatoria, getConvocatoriaId, inscribirPropuesta, idParticipante, descargarArchivo, getConvocatoriaPersistente, convocatoriaPersitente, setConvocatoriaPersitente, loading };
};
